import React from "react";
import { GALLERY } from "@/lib/site";

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-20 md:py-32 bg-slate-50 scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-blue-600">
            The proof
          </p>
          <h2 className="font-display mt-3 text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            Real homes. <span className="text-blue-600">Real results.</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {GALLERY.map((item, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden rounded-2xl ring-1 ring-slate-200 group ${
                i === 0 ? "col-span-2 row-span-2 aspect-square" : "aspect-square"
              }`}
            >
              <img
                src={item.src}
                alt={`Gallery ${i + 1} — ${item.label}`}
                className="absolute inset-0 h-full w-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <span
                className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-[10px] font-black tracking-widest uppercase ${
                  item.label === "After" || item.label === "Finished"
                    ? "bg-blue-600 text-white"
                    : item.label === "Before"
                    ? "bg-white/95 text-slate-700"
                    : "bg-white/95 text-slate-700"
                }`}
              >
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
